import { getCartId } from '@ecomm/data-storage'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useCallback } from 'react'
import { useReplicateCart } from './useReplicateCart'
import { useRequestCart } from './useRequestCart'

/**
 * Restores an abandoned cart:
 * If the cart_id is present in the URL and is different from the cart_id in local storage,
 * Or if the cart_id is not present in local storage and is present in the URL.
 * Otherwise, it requests the cart.
 */
const useRestoreCart = () => {
  const replicateCart = useReplicateCart()
  const requestCart = useRequestCart()

  return useCallback(() => {
    const restoreCart = () =>
      pipe(
        O.fromNullable(
          new URLSearchParams(globalThis.window?.location.search).get('cart_id')
        ),
        O.chain(urlCartId =>
          pipe(
            O.fromNullable(getCartId()),
            O.fold(
              () => O.some(urlCartId),
              localCartId =>
                urlCartId !== localCartId ? O.some(urlCartId) : O.none
            )
          )
        ),
        O.fold(
          () => requestCart(),
          (cartId: string) => {
            replicateCart(cartId)
          }
        )
      )

    restoreCart()
  }, [replicateCart, requestCart])
}

export { useRestoreCart }
